// Single entry point for every toast in the portal, so placement and timing can't drift
// per call site. Installed in main.js; use as this.$notify.success('Saved.').
//
//   this.$notify.success('Your changes are saved.')
//   this.$notify.error('We couldn’t save that.', { title: 'Save failed' })
//   this.$notify.blocked('Add a valid email address first.')   // failed validation
//   this.$notify.error(message, { noAutoHide: true })          // needs acknowledging

// Every toast lands in the same corner. One place to change it.
export const TOASTER = 'b-toaster-bottom-left'

const DEFAULTS = {
  success: { title: 'Saved', variant: 'success', autoHideDelay: 4000 },
  error: { title: 'Error', variant: 'danger', autoHideDelay: 6000 },
  blocked: { title: 'Can’t save yet', variant: 'danger', autoHideDelay: 6000 },
  info: { title: 'Heads up', variant: 'info', autoHideDelay: 5000 },
}

export const buildToast = (kind, options = {}) => ({
  ...DEFAULTS[kind],
  ...options,
  solid: true,
  toaster: TOASTER,
})

const show = (vm, kind, message, options) => {
  // $bvToast is per-component; a vm without it (unmounted, or a plain object in a test)
  // shouldn't take the caller down.
  if (!vm || !vm.$bvToast) return
  vm.$bvToast.toast(String(message), buildToast(kind, options))
}

// The notifier bound to one component. Exported so tests that call methods against a plain
// `this` can build the same thing the plugin hands real components.
export const createNotifier = vm => ({
  success: (message, options) => show(vm, 'success', message, options),
  error: (message, options) => show(vm, 'error', message, options),
  blocked: (message, options) => show(vm, 'blocked', message, options),
  info: (message, options) => show(vm, 'info', message, options),
})

export const notify = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$notify', {
      get() {
        return createNotifier(this)
      },
    })
  },
}

export default notify
